<template>
  <div class="toastbox" v-if="isshow">
      {{content}}
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  data () {
    return {
      content: '',
      isshow: false
    }
  },
  methods: {
    show (content) {
      this.content = content
      this.isshow = true
      setTimeout(() => {
        this.close()
      }, 1000)
    },
    close () {
      this.isshow = false
    }
  }
}
</script>

<style scoped>
    .toastbox{width: auto;height: 50px;padding: 0 10px; line-height: 50px;color: #fff;background: rgba(0, 0, 0, 0.7);position: fixed;top: 50%;left: 50%;transform: translate(-50%,-50%);z-index: 20;}
</style>



// WEBPACK FOOTER //
// src/components/taast/toast.vue